import { AlarmBell, HelpSvg, MyApplicationSvg, TodoSvg } from '@/assets/icon';
import { useNavigate } from '@/utils/useNavigate';
import { useEmotionCss } from '@ant-design/use-emotion-css';
import { Badge, Button, Space, theme } from 'antd';
import classnames from 'classnames';
import { Settings } from './components/settings';
import { User } from './components/user';
import styles from './index.less';
// @ts-ignore
import { hasPermission } from '@/utils';
import { useModel } from '@umijs/max';
import { useState } from 'react';

const { useToken } = theme;

export const RightContentRender = (props) => {
  const { token } = useToken();
  const navigate = useNavigate();
  const { initialState } = useModel('@@initialState');
  const [isChinese, setIsChinese] = useState(true);

  const toggleLanguage = () => {
    setIsChinese(!isChinese);
    // 这里可以添加语言切换的逻辑，比如设置localStorage或调用语言切换API
  };

  const wrapClassName = useEmotionCss(() => {
    return {
      height: '44px',
      lineHeight: '44px',
      color: token.colorTextSecondary,
      cursor: 'pointer',
    };
  });

  const itemWrap = useEmotionCss(() => {
    return {
      color: '#696969',
      // padding: '0 16px',
      margin: '0 4px',
      '&:hover': {
        color: '#000',
      },
    };
  });

  const itemSelected = useEmotionCss(() => {
    return {
      // borderBottom: '4px solid rgba(31, 31, 31, 1) !important',
      color: 'rgb(0, 0, 0)',
      fontWeight: 500,
    };
  });

  return (
    <Space size={8} className={styles.wrap}>
      {hasPermission(['PmsService.MyApplication']) ? (
        <div
          className={wrapClassName}
          onClick={() => navigate('/myApplication')}
        >
          <Space
            className={classnames(itemWrap, {
              [itemSelected]: location.pathname.includes('/myApplication'),
            })}
          >
            <span style={{ position: 'relative', top: '2px' }}>
              <MyApplicationSvg />
            </span>
            <span>我的申请</span>
          </Space>
        </div>
      ) : null}

      {hasPermission(['PmsService.MyTodo']) ? (
        <div className={wrapClassName} onClick={() => navigate('/myTodo')}>
          <Space
            className={classnames(itemWrap, {
              [itemSelected]: location.pathname.includes('/myTodo'),
            })}
          >
            <span style={{ position: 'relative', top: '2px' }}>
              <TodoSvg />
            </span>
            <span>我的待办</span>
          </Space>
        </div>
      ) : null}
      {hasPermission(['PmsService.Feedback']) ? (
        <div
          className={wrapClassName}
          onClick={() =>
            window.open(
              initialState?.isABB
                ? 'https://iticket.abb.com'
                : 'https://iticket.abb.com',
              '_blank',
            )
          }
        >
          <Space
            className={classnames(itemWrap, {
              [itemSelected]: location.pathname.includes('/helpAndFeedback'),
            })}
          >
            <span style={{ position: 'relative', top: '2px' }}>
              <HelpSvg />
            </span>
            <span>帮助与反馈</span>
          </Space>
        </div>
      ) : null}
      {hasPermission(['PmsService.Config']) ? (
        <Settings
          wrapClassName={wrapClassName}
          itemWrap={itemWrap}
          itemSelected={itemSelected}
          {...props}
        />
      ) : null}
      {hasPermission(['PmsService.Notifications']) ? (
        <div className={wrapClassName} onClick={() => navigate('/notice')}>
          <Space
            style={{
              cursor: 'pointer',
              marginRight: props.count ? '30px' : '0',
            }}
            className={classnames(itemWrap, {
              [itemSelected]: location.pathname.includes('/notice'),
            })}
          >
            <span style={{ position: 'relative', top: '2px' }}>
              <AlarmBell />
            </span>
            <Badge size="small" offset={[16, 0]} count={props.count}>
              <span
                className={classnames(itemWrap, {
                  [itemSelected]: location.pathname.includes('/notice'),
                })}
              >
                通知{' '}
              </span>
            </Badge>
          </Space>
        </div>
      ) : null}
      <Button 
        type="text" 
        onClick={toggleLanguage}
        style={{ 
          marginRight: '16px',
          color: token.colorTextSecondary,
          border: '1px solid #d9d9d9',
          borderRadius: '4px'
        }}
      >
        {isChinese ? '中文' : 'English'}
      </Button>
      <User />
    </Space>
  );
};
